import React, { PropTypes } from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { PrimaryButton } from '@bibliocommons/base-buttons';
import { bibShape, userIdentityShape, ugcTagShape } from '@bibliocommons/bc-prop-types';
import TokenizedInput from '@bibliocommons/base-tokenized-input';
import { Personal as PersonalIcon } from '@bibliocommons/base-icons';

import BaseUGCEditor from '../BaseUGCEditor';
import TagDisplay from '../../../../shared/UGC/TagDisplay';
import { TAG_TYPES } from '../../../../../constants/TagsConstants';

import './TagsUGCEditor.scss';

function renderHeader() {
  return (
    <h2><FormattedMessage id="add_tags" /></h2>
  );
}

function filterTagsByType(tags, type) {
  return tags ? tags.filter(tag => tag.get('type') === type).toArray() : [];
}

export class TagsUGCEditor extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleTagSave', 'renderTokenizedInput', 'renderTagDisplay');
  }

  handleTagSave(type, value) {
    const { bib, tagsActions } = this.props;
    const metadataId = bib.getIn(['briefInfo', 'metadataId']);

    tagsActions.addTag(metadataId, type, value);
  }

  renderTagDisplay(tag) {
    const { owner, tagsTransactions, tagsActions } = this.props;
    const tagId = tag.get('id');
    const tagType = tag.get('type');

    return (
      <TagDisplay
        key={`tag-${tagType}-${tagId}`}
        tag={tag}
        owner={owner}
        tagsTransactions={tagsTransactions}
        tagsActions={tagsActions} />
    );
  }

  renderTokenizedInput(type) {
    const { bib, existingTags, tagsTransactions } = this.props;
    const metadataId = bib.getIn(['briefInfo', 'metadataId']);
    const tags = filterTagsByType(existingTags, type);

    return (
      <TokenizedInput
        id={`${type.toLowerCase()}-tags-field`}
        maxInputLength={50}
        tokens={tags}
        renderToken={this.renderTagDisplay}
        getTokenKey={(tag) => tag.get('id')}
        isSaving={tagsTransactions.getIn([metadataId, 'isAdding'], false)}
        handleTokenSave={(value) => this.handleTagSave(type, value)}
        renderNewToken={(value) => this.renderTagDisplay(Immutable.Map({ metadataId, type, value }))} />
    );
  }

  render() {
    const { bib, handleClose } = this.props;

    return (
      <BaseUGCEditor bib={bib} renderHeader={renderHeader} className="cp-tags-ugc-editor">
        <div className="tags-ugc-form">
          <p className="tags-form-help">
            <FormattedMessage id="tags_form_help" />
          </p>

          <div className="form-group">
            <label htmlFor="genre-tags-field">
              <FormattedMessage id="tag_heading_genre" />
            </label>
            <p className="help-info">
              <FormattedMessage id="tag_help_genre" />
            </p>
            {this.renderTokenizedInput(TAG_TYPES.GENRE)}
          </div>

          <div className="form-group">
            <label htmlFor="mood-tags-field">
              <FormattedMessage id="tag_heading_mood" />
            </label>
            <p className="help-info">
              <FormattedMessage id="tag_help_mood" />
            </p>
            {this.renderTokenizedInput(TAG_TYPES.MOOD)}
          </div>

          <div className="form-group">
            <label htmlFor="subject-tags-field">
              <FormattedMessage id="tag_heading_subject" />
            </label>
            <p className="help-info">
              <FormattedMessage id="tag_help_subject" />
            </p>
            {this.renderTokenizedInput(TAG_TYPES.SUBJECT)}
          </div>

          <div className="personal-tags-wrapper">
            <div className="form-group">
              <label htmlFor="personal-tags-field">
                <PersonalIcon /> <FormattedMessage id="tag_heading_personal" />
              </label>
              <p className="help-info">
                <FormattedMessage id="tag_type_personal_description" />
                <FormattedMessage id="tag_help_personal" />
              </p>
              {this.renderTokenizedInput(TAG_TYPES.PERSONAL)}
            </div>
          </div>
        </div>

        <div className="ugc-editor-footer">
          <PrimaryButton handleClick={handleClose}>
            <FormattedMessage id="done" />
          </PrimaryButton>
        </div>
      </BaseUGCEditor>
    );
  }
}

TagsUGCEditor.propTypes = {
  bib: bibShape.isRequired,
  owner: userIdentityShape.isRequired,
  existingTags: ImmutablePropTypes.listOf(ugcTagShape),
  tagsTransactions: ImmutablePropTypes.map.isRequired,
  handleClose: PropTypes.func.isRequired,
  tagsActions: PropTypes.objectOf(PropTypes.func).isRequired
};

export default TagsUGCEditor;



// WEBPACK FOOTER //
// ./app/components/shared/UGC/UGCEditors/TagsUGCEditor/TagsUGCEditor.jsx